import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { NavGuard } from './guards/nav.guard';
import { StoriesWidoPageRoutingModule } from './pages/stories-wido/stories-wido-routing.module';
import { CornerMediaPageRoutingModule } from './pages/corner-tv/components/corner-media/corner-media-routing.module';
import { CornerTargetCustomerPageModule } from './pages/corner-tv/components/corner-target-customer/corner-target-customer.module';
import { CornerMediaPageModule } from './pages/corner-tv/components/corner-media/corner-media.module';
import { ConfigTargetPageModule } from './pages/corner-tv/components/config-target/config-target.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dash',
    pathMatch: 'full'
  },
  {
    path: 'dash',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthGuard, NavGuard],
  },
  {
    path: 'offers-promo', loadChildren: () => import('./pages/offers-promo/offers-promo.module').then(m => m.OffersPromoPageModule),
    canActivate: [AuthGuard],
    data: {
      meta: {
        can: ['MANAGE_OFFERS', 'VIEW_OFFERS', 'MANAGE_SERVICES', 'VIEW_SERVICES']
      }
    }
  },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule) },
  {
    path: 'agencies', loadChildren: () => import('./pages/agencies/agencies.module').then(m => m.AgenciesPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_AGENCIES', 'VIEW_AGENCIES']
      }
    }
  },
  {
    path: 'push-notifications',
    loadChildren: () => import('./pages/push-notifications/push-notifications.module').then(m => m.PushNotificationsPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_PUSH_NOTIFICATIONS', 'VIEW_PUSH_NOTIFICATIONS']
      }
    }
  },
  {
    path: 'faq', loadChildren:
      () => import('./pages/faq/faq.module').then(m => m.FaqPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_FAQ', 'VIEW_FAQ']
      }
    }
  },
  {
    path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_SETTINGS', 'VIEW_SETTINGS']
      }
    }
  },
  {
    path: 'users', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_USERS', 'VIEW_USERS']
      }
    }
  },
  {
    path: 'target-config', loadChildren: () => import('./pages/corner-tv/components/config-target/config-target.module').then(m => m.ConfigTargetPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_USERS', 'VIEW_USERS']
      }
    }
  },
  {
    path: 'corner-tv', loadChildren: () => import('./pages/corner-tv/components/corner-global/corner-global.module').then(m => m.CornerGlobalPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_USERS', 'VIEW_USERS']
      }
    }
  },
  {
    path: 'oms-access',
    loadChildren: () => import('./pages/oms-access/oms-access.module').then(m => m.OmsAccessPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_APP_ACCESS', 'VIEW_APP_ACCESS']
      }
    }
  },
  {
    path: '403',
    loadChildren: () => import('./pages/forbiden/forbiden.module').then(m => m.ForbidenPageModule),
  },
  {
    path: 'tarifs',
    loadChildren: () => import('./pages/tarifs/tarifs.module').then(m => m.TarifsPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_TARRIFS', 'VIEW_TARRIFS'],
      }
    }
  },
  {
    path: 'push-sms',
    loadChildren: () => import('./pages/push-sms/push-sms.module').then(m => m.PushSmsPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_PUSH_NOTIFICATIONS', 'VIEW_PUSH_NOTIFICATIONS']
      }
    }
  },
  {
    path: 'ui-service',
    loadChildren: () => import('./pages/ui-service/ui-service.module').then(m => m.UiServicePageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_APP_SERVICES', 'VIEW_APP_SERVICES']
      }
    }
  },
  {
    path: 'stats',
    loadChildren: () => import('./pages/stats/stats.module').then(m => m.StatsPageModule),
    canActivate: [AuthGuard, NavGuard],
  },
  {
    path: 'sponsorship',
    loadChildren: () => import('./pages/sponsorship/sponsorship.module').then(m => m.SponsorshipPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['VIEW_SPONSORSHIP', 'HISTORIQUE_SPONSORING', 'CONFIGURE_SPONSORING', 'MANAGE_SPONSORING']
      }
    }
  },
  {
    path: 'complains',
    loadChildren: () => import('./pages/complains/complains.module').then( m => m.ComplainsPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_USER_COMPLAINS']
      }
    }
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_NOTIFICATION_MODELS', 'VIEW_NOTIFICATION_MODELS'],
      }
    }
  },
  {
    path: 'fortune-whell',
    loadChildren: () => import('./pages/fortune-well/fortune-well.module').then( m => m.FortuneWellPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_FORTUNE_WELL', 'MANAGE_USER_COMPLAINS']
      }
    }
  },
  {
    path: 'kyc',
    loadChildren: () => import('./pages/kyc/kyc.module').then( m => m.KycPageModule),
    canActivate: [AuthGuard],
    data: {
      meta: {
        can: ['KYC_VALIDATION', 'MANAGE_USERS']
      }
    }
  },
  {
    path: 'stories',
    loadChildren: () => import('./pages/stories/stories.module').then( m => m.StoriesPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'stories-lite',
    loadChildren: () => import('./pages/stories-lite/stories-lite.module').then( m => m.StoriesLitePageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'stories-wido',
    loadChildren: () => import('./pages/stories-wido/stories-wido.module').then( m => m.StoriesWidoPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'corner-offers',
    loadChildren: () => import('./pages/corner-tv/components/corner-offers/corner-offers.module').then( m => m.CornerOffersPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'animation',
    loadChildren: () => import('./pages/kdo/animation/animation.module').then( m => m.AnimationPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'gain',
    loadChildren: () => import('./pages/kdo/gain/gain.module').then( m => m.GainPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'corner-section',
    loadChildren: () => import('./pages/corner-tv/components/corner-section/corner-section.module').then( m => m.CornerSectionPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'corner-media',
    loadChildren: () => import('./pages/corner-tv/components/corner-media/corner-media.module').then( m => m.CornerMediaPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'target-customer',
    loadChildren: () => import('./pages/corner-tv/components/corner-target-customer/corner-target-customer.module').then( m => m.CornerTargetCustomerPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_STORIES', 'VIEW_STORIES']
      }
    }
  },
  {
    path: 'loyalty',
    loadChildren: () => import('./pages/loyalty/loyalty.module').then( m => m.LoyaltyPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_LOYALTY', 'VIEW_LOYALTY']
      }
    }
  },
  {
    path: 'counters',
    canActivate: [AuthGuard, NavGuard],
    loadChildren: () => import('./pages/counters/counters.module').then( m => m.CountersPageModule),
    data: {
      meta: {
        can: ['MANAGE_COUNTERS', 'VIEW_COUNTERS']
      }
    }
  },
  {
    path: 'customers',
    canActivate: [AuthGuard, NavGuard],
    loadChildren: () => import('./pages/customers/customers.module').then( m => m.CustomersPageModule),
    data: {
      meta: {
        can: ['MANAGE_CUSTOMERS']
      }
    }
  },
  {
    path: 'rattachement',
    canActivate: [AuthGuard, NavGuard],
    loadChildren: () => import('./pages/rattachement/rattachement.module').then( m => m.RattachementPageModule),
    data: {
      meta: {
        can: ['MANAGE_CUSTOMERS']
      }
    }
  },
  {
    path: 'dalal-tones',
    loadChildren: () => import('./pages/dalal-tones/dalal-tones.module').then( m => m.DalalTonesPageModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_TONES', 'VIEW_TONES'],
      }
    }
  },
  {
    path: 'home-profit',
    loadChildren: () => import('./pages/home-profit/home-profit.module').then( m => m.HomeProfitModule),
    canActivate: [AuthGuard, NavGuard],
    data: {
      meta: {
        can: ['MANAGE_HOME_PROFIT', 'VIEW_HOME_PROFIT'],
      }
    }
  },
  {
    path: 'rattachement',
    loadChildren: () => import('./pages/rattachement/rattachement.module').then( m => m.RattachementPageModule)
  },
  
  {
    path: 'corner-tv', loadChildren: () => import('./pages/corner-tv/corner-tv.module').then( m => m.CornerTvPageModule),
    canActivate: [AuthGuard, NavGuard],   
    data: {
      meta: {
        can: ['MANAGE_OFFERS', 'VIEW_OFFERS', 'MANAGE_SERVICES', 'VIEW_SERVICES']
      }
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
